export { default } from './CoordinatesInput';
